import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import bluebird from 'utils/bluebird';
import { trimSearch } from '@xmatters/common/utils/searchUtil';
import { getListingURIGenerator } from '@xmatters/redux/actions/listPage/utils';

export const GET_SUPERVISORS = 'GET_SUPERVISORS';
export const GET_SUPERVISORS_START = `${GET_SUPERVISORS}_START`;
export const GET_SUPERVISORS_SUCCESS = `${GET_SUPERVISORS}_SUCCESS`;
export const GET_SUPERVISORS_FAIL = `${GET_SUPERVISORS}_FAIL`;
export const USER_HAS_PERMISSIONS = 'USER_HAS_PERMISSIONS';
export const USER_HAS_PERMISSIONS_SUCCESS = `${USER_HAS_PERMISSIONS}_SUCCESS`;
export const USER_HAS_PERMISSIONS_FAIL = `${USER_HAS_PERMISSIONS}_FAIL`;
export const MODIFY_SUPERVISED_USERS = 'MODIFY_SUPERVISED_USERS';
export const MODIFY_SUPERVISED_USERS_START = `${MODIFY_SUPERVISED_USERS}_START`;
export const MODIFY_SUPERVISED_USERS_SUCCESS = `${MODIFY_SUPERVISED_USERS}_SUCCESS`;
export const MODIFY_SUPERVISED_USERS_FAIL = `${MODIFY_SUPERVISED_USERS}_FAIL`;
export const MODIFY_SUPERVISORS = 'MODIFY_SUPERVISORS';
export const MODIFY_SUPERVISORS_START = `${MODIFY_SUPERVISORS}_START`;
export const MODIFY_SUPERVISORS_SUCCESS = `${MODIFY_SUPERVISORS}_SUCCESS`;
export const MODIFY_SUPERVISORS_FAIL = `${MODIFY_SUPERVISORS}_FAIL`;
export const REMOVE_SUPERVISED_USERS = 'REMOVE_SUPERVISED_USERS';
export const REMOVE_SUPERVISED_USERS_START = `${REMOVE_SUPERVISED_USERS}_START`;
export const REMOVE_SUPERVISED_USERS_SUCCESS = `${REMOVE_SUPERVISED_USERS}_SUCCESS`;
export const REMOVE_SUPERVISED_USERS_FAIL = `${REMOVE_SUPERVISED_USERS}_FAIL`;
export const SEARCH_AVAILABLE_USERS = 'SEARCH_AVAILABLE_USERS';
export const SEARCH_AVAILABLE_USERS_SUCCESS = `${SEARCH_AVAILABLE_USERS}_SUCCESS`;
export const SEARCH_AVAILABLE_USERS_FAIL = `${SEARCH_AVAILABLE_USERS}_FAIL`;
export const SEARCH_SUPERVISED_USERS = 'SEARCH_SUPERVISED_USERS';
export const SEARCH_SUPERVISED_USERS_START = `${SEARCH_SUPERVISED_USERS}_START`;
export const SEARCH_SUPERVISED_USERS_SUCCESS = `${SEARCH_SUPERVISED_USERS}_SUCCESS`;
export const SEARCH_SUPERVISED_USERS_FAIL = `${SEARCH_SUPERVISED_USERS}_FAIL`;
export const SUPERVISED_USERS_CANCEL_BULK_ACTION =
  'SUPERVISED_USERS_CANCEL_BULK_ACTION';
export const SUPERVISORS_CANCEL_BULK_ACTION = 'SUPERVISORS_CANCEL_BULK_ACTION';
export const SUPERVISED_USERS_REFRESH = 'SUPERVISED_USERS_REFRESH';
export const SUPERVISORS_REFRESH = 'SUPERVISORS_REFRESH';
export const SUPERVISED_USERS_RESET_DYNAMIC_FILTERS =
  'SUPERVISED_USERS_RESET_DYNAMIC_FILTERS';
export const SUPERVISED_USERS_SEARCH_FILTER_ITEMS =
  'SUPERVISED_USERS_SEARCH_FILTER_ITEMS';
export const SUPERVISED_USERS_SEARCH_FILTER_ITEMS_START = `${SUPERVISED_USERS_SEARCH_FILTER_ITEMS}_START`;
export const SUPERVISED_USERS_SEARCH_FILTER_ITEMS_SUCCESS = `${SUPERVISED_USERS_SEARCH_FILTER_ITEMS}_SUCCESS`;
export const SUPERVISED_USERS_SEARCH_FILTER_ITEMS_FAIL = `${SUPERVISED_USERS_SEARCH_FILTER_ITEMS}_FAIL`;
export const SUPERVISED_USERS_SET_ACTIVE_DYNAMIC_FILTERS =
  'SUPERVISED_USERS_SET_ACTIVE_DYNAMIC_FILTERS';
export const SUPERVISED_USERS_SET_LOADING = 'SUPERVISED_USERS_SET_LOADING';
export const SUPERVISORS_SET_LOADING = 'SUPERVISORS_SET_LOADING';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_START = `${UPDATE_USER}_START`;
export const UPDATE_USER_SUCCESS = `${UPDATE_USER}_SUCCESS`;
export const UPDATE_USER_FAIL = `${UPDATE_USER}_FAIL`;

const uri = '/webapi/xm/1/people';

const getSitesValue = sites => sites.map(({ value }) => value);

export const SUPERVISED_USERS_FETCH_LIMIT = 1000;

export const getSupervisedUsersParams = props => {
  const {
    startIndex = 0,
    stopIndex = 0,
    search,
    sortBy,
    sortOrder,
    userId,
  } = props;

  const status = get(props, 'status.value');
  const site = get(props, 'sites.value');

  const sortOptions = {
    name: 'FIRST_LAST_NAME',
    userId: 'TARGET_NAME',
    site: 'SITE',
    status: 'STATUS',
  };

  const params = {
    supervisors: userId,
    limit: SUPERVISED_USERS_FETCH_LIMIT,
    offset: 0,
    embed: 'supervisors,roles,permittedActions',
  };

  if (sortBy && sortOrder) {
    params.sortBy = sortOptions[sortBy];
    params.sortOrder = sortOrder;
  }

  params.limit = Math.max(SUPERVISED_USERS_FETCH_LIMIT, stopIndex - startIndex);
  params.offset = startIndex;

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
  }

  if (status && status.length) {
    params.status = status;
  }

  if (!isEmpty(site)) {
    const [siteId] = getSitesValue(site);
    params.site = siteId;
  }

  return params;
};

const getSupervisorsParams = props => {
  const { startIndex = 0, stopIndex = 0, sortBy, sortOrder } = props;

  const sortOptions = {
    name: 'FIRST_LAST_NAME',
    userId: 'TARGET_NAME',
    site: 'SITE',
    status: 'STATUS',
  };

  const params = {
    limit: 100,
    offset: 0,
  };

  if (sortBy && sortOrder) {
    params.sortBy = sortOptions[sortBy];
    params.sortOrder = sortOrder;
  }

  params.limit = Math.max(100, stopIndex - startIndex);
  params.offset = startIndex;

  return params;
};

export const searchSupervisedUsers = props => {
  const params = getSupervisedUsersParams(props);
  return {
    type: SEARCH_SUPERVISED_USERS,
    currentUserId: props.userId,
    meta: {
      xmApi: true,
      uri,
      method: 'get',
      params,
      customUriWithParamsGenerator: getListingURIGenerator,
    },
  };
};

export const getSupervisors = props => {
  const params = getSupervisorsParams(props);
  return {
    type: GET_SUPERVISORS,
    currentUserId: props.userId,
    meta: {
      xmApi: true,
      uri: `${uri}/${props.userId}/supervisors`,
      method: 'get',
      params,
      customUriWithParamsGenerator: getListingURIGenerator,
    },
  };
};

export const userHasPermissions = (id, permissions) => {
  const params = {
    id,
    permissions:
      typeof permissions === 'string' ? permissions : permissions.join(','),
  };
  return {
    type: USER_HAS_PERMISSIONS,
    meta: {
      xmApi: true,
      uri,
      method: 'get',
      params,
    },
  };
};

export const searchAvailableUsers = search => {
  const params = {};

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
    params.fields = ['FIRST_NAME', 'LAST_NAME', 'TARGET_NAME'];
  }

  return {
    type: SEARCH_AVAILABLE_USERS,
    meta: {
      xmApi: true,
      method: 'get',
      uri,
      params,
    },
  };
};
export const updateUser = person => ({
  type: UPDATE_USER,
  meta: {
    xmApi: true,
    method: 'post',
    uri,
    params: person,
  },
});

export const updateSupervisedUsers = users => (dispatch, getState) => {
  const onSuccess = results => {
    dispatch({ type: MODIFY_SUPERVISED_USERS_SUCCESS });
    return results;
  };
  const onFail = e => {
    dispatch({ type: MODIFY_SUPERVISED_USERS_FAIL });
    throw e;
  };

  dispatch({ type: MODIFY_SUPERVISED_USERS });

  return bluebird
    .mapSeries(users, user => {
      if (!getState().supervisedUsers.shouldCancel) {
        return dispatch(updateUser(user)).catch(e => ({ error: e }));
      }
      return Promise.resolve({ error: 'removeCanceled' });
    })
    .then(onSuccess)
    .catch(onFail);
};

export const updateSupervisors = user => dispatch => {
  const onSuccess = results => {
    dispatch({ type: MODIFY_SUPERVISORS_SUCCESS });
    return results;
  };
  const onFail = e => {
    dispatch({ type: MODIFY_SUPERVISORS_FAIL });
    throw e;
  };

  dispatch({ type: MODIFY_SUPERVISORS });

  return dispatch(updateUser(user)).then(onSuccess).catch(onFail);
};

export const refreshSupervisedUsers = () => ({
  type: SUPERVISED_USERS_REFRESH,
});

export const refreshSupervisors = () => ({
  type: SUPERVISORS_REFRESH,
});

export const setIsLoadingSupervisedUsers = () => ({
  type: SUPERVISED_USERS_SET_LOADING,
});
export const setIsLoadingSupervisors = () => ({
  type: SUPERVISORS_SET_LOADING,
});

export const cancelBulkAction = () => ({
  type: SUPERVISED_USERS_CANCEL_BULK_ACTION,
});

export const SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS =
  'SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS';
export const SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS_START = `${SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS}_START`;
export const SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS_SUCCESS = `${SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS}_SUCCESS`;
export const SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS_FAIL = `${SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS}_FAIL`;

export const hydrateActiveDynamicFilters = payload => {
  return {
    type: SUPERVISED_USERS_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
    payload,
  };
};

export const setActiveDynamicFilters = dispatch => (key, items) =>
  dispatch({
    type: SUPERVISED_USERS_SET_ACTIVE_DYNAMIC_FILTERS,
    payload: { key, items },
  });
export const resetDynamicFilters = dispatch => (key, items) =>
  dispatch({
    type: SUPERVISED_USERS_RESET_DYNAMIC_FILTERS,
    payload: { key, items },
  });

export const getFilterItemsBySearch =
  dispatch => async (endpoint, searchTerm) => {
    const filterUri = `/webapi/xm/1/${endpoint}`;

    const params = {
      operand: 'AND',
      fields: 'NAME',
      search: searchTerm,
    };

    try {
      const { payload } = await dispatch({
        type: SUPERVISED_USERS_SEARCH_FILTER_ITEMS,
        meta: {
          xmApi: true,
          method: 'get',
          uri: filterUri,
          params,
        },
        payload: { endpoint },
      });
      return dispatch({
        type: SUPERVISED_USERS_SEARCH_FILTER_ITEMS_SUCCESS,
        payload,
      });
    } catch (error) {
      return dispatch({
        type: SUPERVISED_USERS_SEARCH_FILTER_ITEMS_FAIL,
        payload: { endpoint, error },
      });
    }
  };
